import React, {useEffect, useState} from "react"

import {wowPartnerApi} from "../../../../@shared/apis"
import {StockVod} from "../../../../@shared/apis/wowPartner"

const StockVodContent = () => {
  const [vodList, setVodList] = useState<StockVod[]>([])
  const [isHidden, setIsHidden] = useState(false)

  useEffect(() => {
    wowPartnerApi
      .getStockVod()
      .then((res) => {
        setVodList(res.data.vodList)
      })
  }, [])

  // window height가 920px 이하일때 숨기기
  useEffect(() => {
    const resize = () => {
      if (window.innerHeight <= 920) {
        setIsHidden(true)
      } else {
        setIsHidden(false)
      }
    }

    window.addEventListener("resize", resize)
    resize()

    return () => {
      window.removeEventListener("resize", resize)
    }
  }, [])

  if (isHidden) return null

  const handleClickLintToMore = () => {
    const url = "https://www.wownet.co.kr/StockBrdCsting/StockBrdCstingInfo/WownetTvItemList"
    window.open(url, "_blank")
  }

  return (
    <div className="stockVodWrapper">
      <div className="stockVodInnerWrapper">
        <div className={"title"}>▶ 종목 동영상
          <div className="more" onClick={handleClickLintToMore}>
            전체보기 >
          </div>
        </div>
        <div className="content">
          {vodList.map((vod, index) => (
            <div key={vod.title} className="vodItem">
              <div className="vodContent">
                <img src={vod.imageUrl} alt="vod image url"/>
              </div>
              <div className="vodInfo">
                <div className="vodTitle">{vod.title}</div>
                <div className="vodDate">{vod.regdate}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StockVodContent
